import { JsonApiDocument } from '../services/spree-client/core';

export const filterAttachments = (
  attachments: JsonApiDocument[],
  type: string,
  ids: string[]
): JsonApiDocument[] =>
  attachments.filter(
    (attachment) => attachment.type === type && ids.includes(attachment.id)
  );

export const extractSingleRelationship = (
  attachments: JsonApiDocument[],
  relationshipsName: string,
  item: JsonApiDocument
): JsonApiDocument | undefined => {
  const relationshipData = item.relationships[relationshipsName]?.data as
    | JsonApiDocument
    | undefined;

  return attachments.find(
    (e) => e.type === relationshipData?.type && e.id === relationshipData?.id
  );
};

export const extractRelationships = (
  attachments: JsonApiDocument[],
  documentType: string,
  relationshipsName: string,
  item: JsonApiDocument
): JsonApiDocument[] => {
  const relationships = item.relationships[relationshipsName]?.data as
    | JsonApiDocument
    | JsonApiDocument[]
    | undefined;

  if (!relationships) {
    return [];
  }

  if (!Array.isArray(relationships)) {
    throw new Error(`Expected ${relationshipsName} to be a one-to-many relation.`);
  }

  return filterAttachments(
    attachments,
    documentType,
    relationships.map((relationship) => relationship.id)
  );
};
